import React, { useEffect, useState, useCallback, useRef } from "react"; // toda página
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, cloneDeep } from 'lodash';
import * as actions from "../../../store/actions";
import moment from "moment";
import siteObjectToQuery from "../../../utils/siteObjectToQuery";

import {
  Paper, Container,Chip, Table, TableBody, TableCell, TableFooter, TablePagination, TableRow, Typography, CircularProgress, IconButton, Button, Checkbox,
} from '@mui/material';

import EnhancedTableHead from "../../../UI/MaterialTableOverrides/EnhancedTableHead";
import TablePaginationActionsWrapped from "../../../UI/MaterialTableOverrides/TablePaginationActions";
import TableTitle from '../../../UI/MaterialTableOverrides/TableTitle';
import TableActionButtonsStatic from "../../../UI/MaterialTableOverrides/TableActionButtonsStatic";
import { deleteCheckMessage } from "../../../utils/deleteCheckMessage";
import api from "../../../axios/api"
import * as xlsx from 'xlsx';
import Autocomplete from '../../../UI/Autocomplete/Autocomplete';

function prepareRows(rows, columns) {
  let preparedRows = [];

  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    // const newObject = { checked: false };
    const newObject = {};

    columns.forEach(({ id, label, fromColumn, valueType }, index) => {
      if (row[fromColumn] && valueType === 'multiple') {
        const keys = Object.keys(row).filter((key) => key.includes(fromColumn));
        newObject[id] = keys.map((key) => row[key]).join(', ');
      } else if (row[fromColumn]) {
        if (valueType === 'date') {
          const dateSplitted = row[fromColumn].split("/");
          const day = Number(dateSplitted[0]);
          const month = Number(dateSplitted[1]);
          const year = Number(dateSplitted[2]?.length === 2 ? '20' + dateSplitted[2] : dateSplitted[2]);
          const date = moment().set({date: day, month: month - 1, year});
          newObject[id] = date.format('DD/MM/YYYY'); // formata a data para dd/mm/yyyy
        } else {
          newObject[id] = typeof row[fromColumn] === 'string' ? row[fromColumn] : row[fromColumn].toString();
        }
      } else {
        newObject[id] = '';
      }
    });

    preparedRows.push({ status: 'none', data: newObject, invalidFields: [] });
  }

  return preparedRows;
}

export const MassiveImport = (props) => {
  const dispatch = useDispatch();
  const type = props.type || props.match.params.type;
  const language = 'pt';

  // CONTROLE DA TABELA
  const [loadingDownloadModel, setLoadingDownloadModel] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [rows, setRows] = useState([]); // LINHAS DA TABELA
  const [header, setHeader] = useState([]); // CABEÇALHO DA TABELA
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchTextEquipmentModels, setSearchTextEquipmentModels] = useState('');
  const [selectedEquipmentModel, setSelectedEquipmentModel] = useState({value: '', label: ''});
  const [equipmentModelsError, setEquipmentModelsError] = useState(false);
  const pageEquipmentModels = 1;
  const limitEquipmentModels = 50;
  const orderEquipmentModels = 'asc';
  const orderByEquipmentModels = 'name';

  const fetchEquipmentModels = useCallback(
    () => dispatch(actions.equipmentsFetchEquipmentModels(page, limit, searchTextEquipmentModels, orderEquipmentModels, orderByEquipmentModels)),
    [pageEquipmentModels, limitEquipmentModels, searchTextEquipmentModels, orderEquipmentModels, orderByEquipmentModels]
  );

  const loadingEquipmentModels = useSelector(state => state.equipments.equipmentModelsLoading);
  const equipmentModels = useSelector(state => state.equipments.equipmentModels);
  const equipmentModelsFormated = equipmentModels.rows.map(equipmentModel => ({ value: equipmentModel._id, label: equipmentModel.name }))
  const questionsSites = useSelector((state) => state.sites.selectedSitesQuestions);
  const equipmentSites = useSelector((state) => state.sites.selectedSitesPlaces);


  useEffect(() => {
    if (type === 'service') fetchEquipmentModels();
  },[searchTextEquipmentModels]);

  const handleChangePage = (e, page) => {
    setPage(page + 1);
  };

  const handleChangeLimit = e => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleRemoveRow = (index) => {
    setRows([...rows.slice(0, index), ...rows.slice(index + 1)]);
  }
  // ------------------------------

  // CABEÇALHO DA TABELA
  const tableHeader = [
    ...header,
    { id: 'remocao', label: 'Remover' }
  ];
  // ------------------------------

  // DOWNLOAD E UPLOAD DE ARQUIVO XLSX
  const downloadModel = async () => {
    let hasError = false;
    if (type === 'service' && selectedEquipmentModel.value === '') {
      setEquipmentModelsError(true);
      hasError = true;
    }

    if (hasError) return;

    setLoadingDownloadModel(true);
    
    try {
        let url_to_template = `/templates?type=${type}&language=${language}`
        if (type === 'equipment') {
          url_to_template += `${equipmentSites && equipmentSites.length > 0 ? `&sites=${siteObjectToQuery(equipmentSites) }` : ''}`;
        }
        if (type === 'service') url_to_template += `&equipmentModel=${selectedEquipmentModel.value}`;
        const response = await api.get(url_to_template, {responseType: 'arraybuffer'}); // CHAMADA PARA API
        const contents = response.data; // CONTEÚDO RETORNADO, NO CASO O ARQUIVO XLSX

        const options = {
          suggestedName: `${type}-${Date.now()}.xlsx`, // NOME SUGERIDO PARA SALVAR ARQUIVO
          types: [
            {
              description: 'Excel Files',
              accept: {
                'text/plain': ['.xlsx'],
              },
            },
          ],
        };

        const fileHandle = await window.showSaveFilePicker(options);

        // Create a FileSystemWritableFileStream to write to.
        const writable = await fileHandle.createWritable();

        // Write the contents of the file to the stream.
        await writable.write(contents);

        // Close the file and write the contents to disk.
        await writable.close();

        setLoadingDownloadModel(false);
    } catch (error) {
        setLoadingDownloadModel(false);
        // throw Error(error);
    }
  }

  const uploadFile = async () => {
    const pickerOpts = {
      types: [
        {
          description: 'Excel Files',
          accept: {
            'text/plain': ['.xlsx']
          }
        },
      ],
      excludeAcceptAllOption: true,
      multiple: false
    };

    const [fileHandle] = await window.showOpenFilePicker(pickerOpts);
    const file = await fileHandle.getFile();

    let reader = new FileReader();

    reader.addEventListener("loadend", () => {
      setLoadingUpload(true);
      const workbook = xlsx.read(reader.result, { type: 'ArrayBuffer', cellDates:true, dateNF: 'dd"/"mm"/"yyyy'});

      const worksheet = workbook.Sheets['main'];
      const dataFromWorksheet = xlsx.utils.sheet_to_json(worksheet, {raw: false });

      const worksheetStructure = workbook.Sheets['structure'];
      const dataFromWorksheetStructure = xlsx.utils.sheet_to_json(worksheetStructure, { header:1 });

      const [fromColumns, ids, labels, valueTypes] = dataFromWorksheetStructure;
      
      const organizedHeader = [];
      for (let i = 0; i < ids.length; i++) organizedHeader.push({ fromColumn: fromColumns[i], id: ids[i], label: labels[i], valueType: valueTypes[i]  });

      const rows = prepareRows(dataFromWorksheet, organizedHeader);

      setHeader(organizedHeader);
      setRows(rows);

      setLoadingUpload(false);
    });

    reader.readAsArrayBuffer(file);
  }

  const downloadExcel = async () => {

    let hasError = false;
    if (type === 'service' && selectedEquipmentModel.value === '') {
      setEquipmentModelsError(true);
      hasError = true;
    }

    if (hasError) return;
    setLoadingDownloadModel(true);
    
    try {
      let url_to_template = `/templates/file?type=${type}&language=${language}`
      if (type === 'equipment') {
        url_to_template += `${equipmentSites && equipmentSites.length > 0 ? `&sites=${siteObjectToQuery(equipmentSites)}` : ''}`;
      }
      if (type === 'service') url_to_template += `&equipmentModel=${selectedEquipmentModel.value}`;
       const response = await api.post(url_to_template, rows.filter(({ status }, index) => status !== 'valid'), { responseType: 'arraybuffer' }); // CHAMADA PARA API
        const contents = response.data; // CONTEÚDO RETORNADO, NO CASO O ARQUIVO XLSX

        const options = {
          suggestedName: `${type}-${Date.now()}.xlsx`, // NOME SUGERIDO PARA SALVAR ARQUIVO
          types: [
            {
              description: 'Excel Files',
              accept: {
                'text/plain': ['.xlsx'],
              },
            },
          ],
        };

        const fileHandle = await window.showSaveFilePicker(options);

        // Create a FileSystemWritableFileStream to write to.
        const writable = await fileHandle.createWritable();

        // Write the contents of the file to the stream.
        await writable.write(contents);

        // Close the file and write the contents to disk.
        await writable.close();

        setLoadingDownloadModel(false);
    } catch (error) {
        setLoadingDownloadModel(false);
        // throw Error(error);
    }
  }
  // ------------------------------
  // SE FOR TIPO CHECKLIST, ENVIA EM CADA LINHA O SITE SELECIONADO E O EQUIPMENTSERVICEID

  const feedChecklistRow = (rows, type) => {
    if (type === 'checklist') {
      const newRows = cloneDeep(rows);
      newRows.forEach((row) => {
        row.data.site = questionsSites[0]._id;
        row.data.equipmentServiceId = props.equipmentServiceId;
      })
      return newRows;
    }
    return rows
  }

  // ------------------------------

  const importData = async () => {
    try {
      setLoadingUpload(true);
      const response = await api.post(`/templates?type=${type}&language=${language}`, feedChecklistRow(rows, type)); // CHAMADA PARA API
      const contents = response.data; // CONTEÚDO RETORNADO, NO CASO O ARQUIVO XLSX
      setLoadingUpload(false);
      if (contents && contents.newEntries && contents.entriesNotCreated && contents.invalidData) {      
        setRows((prevRows) =>
          prevRows.map(({ status, data, invalidFields }, index) => {
            const newEntry = contents.newEntries.find((obj) => obj.index === index);
            if (newEntry) return ({ status: 'valid', data, invalidFields });
  
            const entryNotCreated = contents.entriesNotCreated.find((obj) => obj.index === index);
            if (entryNotCreated) return ({ status: 'invalid', data, invalidFields });
  
            const entryWithInvalidData = contents.invalidData.find((obj) => obj.index === index);
            if (entryWithInvalidData) return ({ status: 'invalid', data, invalidFields: entryWithInvalidData.invalidReasons.map((obj) => obj.field) });
          
            return ({ status, data, invalidFields });
          })
        );
      }
    } catch (e) {
      setLoadingUpload(false);
    }
  }
  const renderSitesChips = () => (equipmentSites && equipmentSites.map((site) => (<Chip key={site._id} label={site.name} style={styles.filterChip} />)))

  return <>
    <Container maxWidth='xl'>
      <Paper>
        <TableTitle
          title='Importação'

          addFromExcelLabel="Carregar arquivo"
          addFromExcel={() => uploadFile()}

          showDownloadExcelModelButton={true}
          downloadExcelModelLabel="Baixar modelo"
          downloadExcelModel={() => downloadModel()}

          showDownloadExcelButton={!rows.every(({ status }) => status !== 'invalid')}
          downloadExcelLabel="Corrigir dados em planilha"
          downloadExcel={() => downloadExcel()}

          showImportButton={rows.length > 0 && rows.every(({ status }) => status === 'none')}
          importButtonLabel={"Importar Dados"}
          clickImportButton={() => importData()}
          hideSearchInput
        />
        <div style={styles.filterChipContainer}>
          {type === 'equipment' && renderSitesChips()}
          {type === 'service' &&
          <div style={{width: '40%'}}>
            <Autocomplete
              loading={loadingEquipmentModels} // sent to isLoading
              label={'Tipos de Equipamento'}
              data={equipmentModelsFormated} // sent to options
              onSelectValue={(selected) => {
                setEquipmentModelsError(false);
                if (selected) setSelectedEquipmentModel(selected);
                else setSelectedEquipmentModel({value: '', label: ''});
              }} // sent to onChange
              valueSelected={selectedEquipmentModel} // sent to value
              newSearchText={(text) => setSearchTextEquipmentModels(text)}
              name='equipmentModel'
              hasError={equipmentModelsError}
              isMulti={false}
            />
            </div>
          }
        </div>
        <Table style={styles.table}>
          <tbody>
            <tr>
              <td>
                {(loadingUpload || loadingDownloadModel) &&
                  <div style={styles.spinner}><CircularProgress /></div>
                }
                { (rows && rows.length === 0) &&
                  <div style={{...styles.noResults, ...styles.opacityContainer(loadingUpload || loadingDownloadModel)}}>
                    {loadingUpload && <Typography style={styles.spinner}>Carregando arquivo</Typography>}
                    {loadingDownloadModel && <Typography style={styles.spinner}>Baixando modelo para importação</Typography>}
                    {!loadingDownloadModel && <Typography style={styles.spinner}>Baixe o modelo para importação ou importe de um arquivo</Typography>}
                  </div>
                }
              </td>
            </tr>
          </tbody>
          {(rows && rows.length !== 0) &&
            <EnhancedTableHead
              style={styles.opacityContainer(loadingUpload || loadingDownloadModel)}
              headRows={tableHeader}
              onRequestSort={() => {}}
              order='asc'
              orderBy=''
            />
          }
          <TableBody style={{ ...styles.tableBody, ...styles.opacityContainer(loadingUpload || loadingDownloadModel) }}>
            {rows.filter((_, index) => (index >= (page - 1) * limit && index < page * limit)).map((row, index) => (
              <TableRow
                key={index}
                hover
                style={styles.row(row.status)}
              >
                {Object.keys(row.data).map((key, indexKey) => <TableCell style={styles.cell(row.invalidFields.includes(key) ? 'invalid' : 'none')} key={key}>{row.data[key]}</TableCell>)}
                <TableCell style={styles.cell('none')}>
                  <Button
                    variant='outlined'
                    aria-label="add"
                    onClick={() => handleRemoveRow(index)}
                    disabled={!rows.every(({ status }) => status === 'none')}
                  >
                    REMOVER
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          { (rows && rows.length > 0) &&
            <TableFooter style={styles.opacityContainer(loadingUpload || loadingDownloadModel)}>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25]}
                  count={rows.length}
                  rowsPerPage={parseInt(limit)}
                  page={page-1}
                  SelectProps={{
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeLimit}
                  ActionsComponent={TablePaginationActionsWrapped}
                />
              </TableRow>
            </TableFooter>
          }
        </Table>
      </Paper>
    </Container>
  </>;
}

export default MassiveImport;

const validationColors = {
  valid: (isCell) => `rgba(76, 175, 80, 1)`,
  invalid: (isCell) => isCell ? 'rgba(244,67,54,1)' : 'rgba(219,60,48,1)',
  none: (isCell) => 'transparent'
}

const styles = {
  label: {
    marginLeft: '0.5rem'
  },
  table: {
    paddingLeft: 20,
    position: 'relative',
    marginBottom: '4rem',
  },
  opacityContainer: (loading) => ({
    opacity: loading ? '0.3' : '1',
  }),
  tableBody: {
    cursor: 'pointer',
  },
  spinner: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    top: '-5px',
    opacity: '1',
    zIndex: 2,
  },
  noResults: {
    height: '100px',
  },
  deleteTextConfirm: {
    marginLeft: '-30px',
    fontWeight: 'bold',
  },
  editWidth: {
    width: '90%'
  },
  filterChip: {
    margin: 5,
  },
  filterChipContainer: {
    paddingLeft: 20,
    display: 'flex',
    flexWrap: 'wrap',
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 10,
  },
  cell: (status) => ({
    fontSize: '0.775rem',
    padding: '0.25rem',
    backgroundColor: validationColors[status](true)
  }),
  row: (status) => ({
    backgroundColor: validationColors[status](false)
  })
}